import React from 'react'
import { Link } from 'react-router-dom'
import { HomePath } from '../home-path'

export default function Find() {
  return (
    <div className="w-full py-12">
        <div className="mxw pt-4 border-t border-t-gray-100">
            <p className="text-2xl md:text-3xl font-semibold">
              <Link to={HomePath + "/locations"}>Discover Our Brand</Link>
            </p>
        </div>
    </div>
  )
}